export enum RouteAnimation {
	SLIDE_TOP = 'full-slide-top',
	SLIDE_RIGHT = 'full-slide-right',
	SLIDE_DOWN = 'full-slide-down',
	SLIDE_LEFT = 'full-slide-left',
}
